module.exports = __webpack_public_path__ + "static/img/header_logo_pc.2305a40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homePage/index/PCImage/header_logo_pc.png
// module id = 13mP
// module chunks = 1